import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import "../style/SectionContact.css";

const SectionContact = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  const navigate = useNavigate();
  return (
    <section className="contact-section">
      <div
        className="contact-content"
        data-aos="fade-left"
        data-aos-duration="1000"
      >
        <h2>Let’s Find Together The Perfect Solution For Your Need</h2>
        <h3>
          Get in touch with us for reliable and precise steel detailing
          solutions tailored to your project needs.
        </h3>
        <div>
          <button
            className="contact-button"
            onClick={() => navigate("/contactus")}
          >
            Contact us →
          </button>
        </div>
      </div>
    </section>
  );
};

export default SectionContact;
